import { render, staticRenderFns } from "./u-header-body-basic.vue?vue&type=template&id=785e2ff8&scoped=true"
import script from "./u-header-body-basic.vue?vue&type=script&lang=js"
export * from "./u-header-body-basic.vue?vue&type=script&lang=js"
import style0 from "./u-header-body-basic.vue?vue&type=style&index=0&id=785e2ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785e2ff8",
  null
  
)

export default component.exports